import { createContext } from 'react';

export const FlowInstancesContext = createContext(null);
FlowInstancesContext.displayName = 'Flow Instances';